import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Layout from "./components/shared/Layout";
import Login from "./pages/Login";
import Employee from "./pages/Employee";
import Attendance from "./pages/Attendance";
import Task from "./pages/Task";
import Logout from "./pages/Logout";
import { Toaster } from "react-hot-toast";
import ProtectedRoute, { PublicRoute } from "./private/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import Geofence from "./pages/geofence";
import AddUser from "./pages/AddUser";
import UserAddBulk from "./pages/UserAddBulk";
import Viewdistricts from "./pages/Viewdistricts";
import ViewMunicipalitie from "./pages/ViewMunicipalitie";
import CreateDistricts from "./pages/Districts/CreateDistricts";
import CreateMunicipality from "./pages/Municipality/CreateMunicipality";
import ViewAdmin from "./pages/viewAdmin";
import ParkGeofence from "./pages/parkGeofence";
import AttendanceReport from "./pages/AttendanceReport";
import OffenseMaster from "./pages/survey-management/offense-master/OffenseMaster";
import Challan from "./pages/survey-management/challan/Challan";
import SurveyOfficers from "./pages/user-management/SurveyOfficers";
import AdminDashboard from "./pages/admin-dashboard/AdminDashboard";
import Role from "./pages/role-management/role/Role";
import Permission from "./pages/role-management/permission/Permission";
import AssignPermission from "./pages/role-management/assignPermission/AssignPermission";
import ULBUsers from "./pages/user-management/ULBUsers";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Toaster
          position="top-right"
          toastOptions={{ style: { background: "#f2f2f2", color: "#000000" } }}
        />

        <Routes>
          <Route
            path="/auth"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          <Route path="/" element={<Navigate to="/auth" replace />} />

          <Route path="/logout" element={<Logout />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route
              index
              element={
                <ProtectedRoute
                  requiredPermissions={[
                    "overall_dashboard_stats",
                    "dashboard_challan_stats",
                    "dashboard_officer_stats",
                  ]}
                >
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />

            {/* Employee Management */}
            <Route
              path="employee"
              element={
                <ProtectedRoute requiredPermissions={["manage_users"]}>
                  <Employee />
                </ProtectedRoute>
              }
            />

            {/* Attendance */}
            <Route
              path="attendance"
              element={
                <ProtectedRoute requiredPermissions={["view_attendance"]}>
                  <Attendance />
                </ProtectedRoute>
              }
            />
            <Route
              path="attendance-report"
              element={
                <ProtectedRoute
                  requiredPermissions={["view_attendance_report"]}
                >
                  <AttendanceReport />
                </ProtectedRoute>
              }
            />

            {/* Task Management */}
            <Route
              path="task"
              element={
                <ProtectedRoute requiredPermissions={["view_tasks"]}>
                  <Task />
                </ProtectedRoute>
              }
            />

            {/* Geofence Management */}
            <Route
              path="geofence"
              element={
                <ProtectedRoute requiredPermissions={["view_geofence"]}>
                  <Geofence />
                </ProtectedRoute>
              }
            />
            <Route
              path="parkGeofence"
              element={
                <ProtectedRoute requiredPermissions={["view_geofence"]}>
                  <ParkGeofence />
                </ProtectedRoute>
              }
            />

            {/* User Management */}
            <Route
              path="User-add"
              element={
                <ProtectedRoute requiredPermissions={["User_add"]}>
                  <AddUser />
                </ProtectedRoute>
              }
            />
            <Route
              path="User-add-bulk"
              element={
                <ProtectedRoute requiredPermissions={["User_Add_Bulk"]}>
                  <UserAddBulk />
                </ProtectedRoute>
              }
            />

            {/* Survey Officers - View */}
            <Route
              path="survey-officers"
              element={
                <ProtectedRoute requiredPermissions={["view_survey_officers"]}>
                  <SurveyOfficers />
                </ProtectedRoute>
              }
            />

            {/* ULB Users - View */}
            <Route
              path="ulb-users"
              element={
                <ProtectedRoute requiredPermissions={["view_ulb_users"]}>
                  <ULBUsers />
                </ProtectedRoute>
              }
            />

            {/* ULB Management */}
            <Route
              path="View-districts"
              element={
                <ProtectedRoute requiredPermissions={["view_districts"]}>
                  <Viewdistricts />
                </ProtectedRoute>
              }
            />
            <Route
              path="Create-Districts"
              element={
                <ProtectedRoute requiredPermissions={["create_districts"]}>
                  <CreateDistricts />
                </ProtectedRoute>
              }
            />
            <Route
              path="View-Municipalitie"
              element={
                <ProtectedRoute requiredPermissions={["view_municipalities"]}>
                  <ViewMunicipalitie />
                </ProtectedRoute>
              }
            />
            <Route
              path="Create-Municipality"
              element={
                <ProtectedRoute requiredPermissions={["create_municipalities"]}>
                  <CreateMunicipality />
                </ProtectedRoute>
              }
            />
            <Route
              path="View-Admin"
              element={
                <ProtectedRoute requiredPermissions={["view_ulb_admin"]}>
                  <ViewAdmin />
                </ProtectedRoute>
              }
            />

            {/* Challan Management */}
            <Route
              path="offense-master"
              element={
                <ProtectedRoute requiredPermissions={["view_offense"]}>
                  <OffenseMaster />
                </ProtectedRoute>
              }
            />
            <Route
              path="challan"
              element={
                <ProtectedRoute requiredPermissions={["view_challan"]}>
                  <Challan />
                </ProtectedRoute>
              }
            />

            {/* Role Management */}
            <Route
              path="create-role"
              element={
                <ProtectedRoute requiredPermissions={["create_role"]}>
                  <Role />
                </ProtectedRoute>
              }
            />
            <Route
              path="create-permission"
              element={
                <ProtectedRoute requiredPermissions={["create_permission"]}>
                  <Permission />
                </ProtectedRoute>
              }
            />
            <Route
              path="assign-permission"
              element={
                <ProtectedRoute
                  requiredPermissions={["assign_permission_to_role"]}
                >
                  <AssignPermission />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
